<template>
  <div class="formulate-input">
    <div class="formulate-input-wrapper">
      <!-- <div class="formulate-input-wrapper"> -->
      <label
        class="formulate-input-label pb-2"
        style="margin: 0"
        :for="id"
        >{{ labelText }}</label
      >
      <div
        data-type="text"
        class="formulate-input-element formulate-input-element--text"
      >
        <money
          placeholder="$lang.Currency.Placeholder"
          max-length="12"
          v-model.lazy="localValue"
          v-bind="$lang.Currency.Format"
          @input="updateLocalValue"
        ></money>
      </div>
    </div>
  </div>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxMoney',
  mixins: [useReactiveModelMixin('value')],
  props: {
    labelText: {
      type: String,
      required: false,
      default: 'Selecione:'
    },
    id: {
      type: String,
      required: true,
      default: null
    }
  },
  created () {
    this.$root.$on('clearForm', () => {
      this.localValue = 0
    })
  },
  methods: {
    updateLocalValue (newValue) {
      this.localValue = newValue
    }
  }
}
</script>
<style lang="scss" scoped>
.v-money {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 0.9em;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  padding: 0.75em;
  display: block;
  width: 100%;
  height: 2.2rem;
  font-weight: 400;
  line-height: 1.2em;
  margin: 0;
  padding: 8px;

  &:focus {
    outline: 0;
    border: 1px solid #41b883;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/inputs/NxMoney.vue